module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-sunglasses-fill-720c6307.svg";